import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findPractitioners = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/practitioners${query}`,
    {
      headers,
    },
  );
};

export const findPractitionerById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/practitioners/${id}`,
    {
      headers,
    },
  );
};

export const findPractitionerByMyself = (headers) => {
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/practitioners/myself`,
    {
      headers,
    },
  );
};

export const uploadPhoto = (headers, id, data) => {
  return axios.put(
    `${process.env.REACT_APP_INFO_API_URL}/practitioners/${id}/photo`,
    data,
    {
      headers,
    },
  );
};

export const createPractitioner = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_INFO_API_URL}/practitioners`,
    data,
    {
      headers,
    },
  );
};

export const updatePractitioner = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_INFO_API_URL}/practitioners/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deletePractitioner = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_INFO_API_URL}/practitioners/${id}`,
    {
      headers: headers,
    },
  );
};
